var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5794 16.9498L6.2642 19.9187C5.19109 20.2291 4.07775 19.6083 3.76923 18.5287L0.0804303 5.55975C-0.228087 4.48013 0.388948 3.36002 1.46205 3.04963L11.7773 0.0806687C12.8504 -0.229723 13.9637 0.39106 14.2722 1.47068L17.961 14.4396C18.2561 15.5193 17.6391 16.6394 16.5794 16.9498ZM1.82423 4.34518C1.46205 4.45314 1.26085 4.81751 1.36816 5.18188L5.05696 18.1508C5.16427 18.5152 5.52644 18.7176 5.88861 18.6097L16.2038 15.6407C16.566 15.5328 16.7672 15.1684 16.6599 14.804L12.9711 1.83505C12.8638 1.47068 12.5016 1.26825 12.1394 1.37622L1.82423 4.34518Z",
    fill: "#242558"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0861 19.5417C11.8178 19.5417 11.563 19.4607 11.3349 19.3123L6.62667 16.1139C6.00964 15.6956 5.84867 14.8588 6.2645 14.2381C6.68033 13.6173 7.51198 13.4553 8.12902 13.8737L11.563 16.2084L17.4516 4.45398C17.787 3.79271 18.5918 3.5228 19.2491 3.86018C19.9063 4.19757 20.1746 5.00728 19.8393 5.66855L13.2665 18.813C13.0921 19.1638 12.7836 19.4203 12.408 19.5147C12.3141 19.5282 12.1934 19.5417 12.0861 19.5417Z",
    fill: "url(#paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5225 5.06084L4.29244 7.15261C3.93027 7.26058 3.56809 7.04465 3.46078 6.69377C3.35347 6.3294 3.56809 5.96503 3.91685 5.85707L11.1469 3.77879C11.5091 3.67083 11.8713 3.88675 11.9786 4.23763C12.0859 4.58851 11.8847 4.96638 11.5225 5.06084Z",
    fill: "#242558"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2603 7.66516L5.03023 9.74344C4.66806 9.8514 4.30588 9.63548 4.19857 9.2846C4.09126 8.92022 4.30588 8.55585 4.65464 8.44789L11.8847 6.36961C12.2469 6.26165 12.609 6.47757 12.7163 6.82845C12.8237 7.17933 12.6224 7.5572 12.2603 7.66516Z",
    fill: "#242558"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74587 11.4846L5.76799 12.3348C5.40582 12.4428 5.04365 12.2269 4.93634 11.876C4.82903 11.5116 5.04365 11.1472 5.39241 11.0393L8.35686 10.1891C8.71904 10.0811 9.08121 10.297 9.18852 10.6479C9.30925 10.9988 9.09463 11.3767 8.74587 11.4846Z",
    fill: "#242558"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 5.81169,
    y1: 14.3817,
    x2: 21.4354,
    y2: 9.93276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AAB58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#438546"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon);
export default __webpack_public_path__ + "static/media/report-icon.c63da900014f2674169c024d1d1df9cb.svg";
export { ForwardRef as ReactComponent };